import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";

const MobileMenu = ({ menuData, logo }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const toggleSubMenu = (index) => {
    setExpandedMenu((prev) => (prev === index ? null : index));
  };

  return (
    <>
      {/* Botón de menú hamburguesa */}
      <IconButton edge="start" aria-label="menu" onClick={toggleDrawer(true)}>
        <MenuIcon />
      </IconButton>

      {/* Drawer lateral */}
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: "65vw", padding: 2 }}>
          {/* Encabezado del menú móvil */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            <img
              src={logo} // Cambia al logo de tu sitio
              alt="Logo"
              style={{ height: "40px" }}
            />
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

         {/* Menú principal */}
<List>
  {menuData.map((menu, index) => (
    <React.Fragment key={index}>
      <ListItem disablePadding>
        <ListItemButton
          component={menu.subMenus?.length > 0 ? "div" : Link}
          to={menu.subMenus?.length > 0 ? undefined : menu.link}
          onClick={() => {
            if (menu.subMenus?.length > 0) {
              toggleSubMenu(index); // Abre o cierra el submenú
            } else {
              toggleDrawer(false)(); // Cierra el drawer
            }
          }}
        >
          <ListItemText
            primary={menu.name}
            primaryTypographyProps={{
              fontWeight: "bold", // Texto en bold
              color: "primary.main", // Asegúrate que use el color correcto
            }}
          />
          {menu.subMenus?.length > 0 &&
            (expandedMenu === index ? (
              <ExpandLessIcon />
            ) : (
              <ExpandMoreIcon />
            ))}
        </ListItemButton>
      </ListItem>
      <Divider component="li" />
      {/* Submenús */}
      {menu.subMenus?.length > 0 && (
        <Collapse in={expandedMenu === index} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <Divider component="li" />
            {menu.subMenus.map((subMenu, subIndex) => (
              <ListItemButton
                key={subIndex}
                sx={{
                  pl: 2, // Padding izquierdo
                  display: "flex",
                  alignItems: "center",
                  gap: 1, // Espacio entre el marcador y el texto
                  background: "grayLight.main", // Fondo gris claro
                  borderBottom: `1px solid dividerMobile.main`, // Borde inferior
                  "&:last-child": {
                    borderBottom: "none", // Elimina el borde para el último elemento
                  },
                }}
                onClick={toggleDrawer(false)}
                component={Link}
                to={subMenu.link}
              >
                <ListItemText
                  primary={subMenu.name}
                  primaryTypographyProps={{
                    fontWeight: "bold", // Texto en bold
                  }}
                />
              </ListItemButton>
            ))}
            <Divider component="li" />
          </List>
        </Collapse>
      )}
    </React.Fragment>
  ))}
</List>

        </Box>
      </Drawer>
    </>
  );
};

MobileMenu.propTypes = {
  menuData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      link: PropTypes.string,
      subMenus: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
  logo: PropTypes.string.isRequired,
};

export default MobileMenu;
